import {
    put, call, takeLatest
} from 'redux-saga/effects';
import { axios, authenticatedAxios } from '../client';
import {
    UPDATE_ACTIVE_ITEM,
    updateActiveItemFailure,
    updateActiveItemSuccess,
    FETCH_AWS_UPLOAD_DETAILS,
    fetchAwsUploadDetailsFailure,
    fetchAwsUploadDetailsSuccess, UPLOAD_VIDEO, uploadVideoSuccess, uploadVideoFailure, START_VIDEO_TRANSCODE,
    startVideoTranscodeSuccess, startVideoTranscodeFailure, checkVideoTranscodeStatusSuccess,
    checkVideoTranscodeStatusFailure, CHECK_VIDEO_TRANSCODE_STATUS,
    UPLOAD_IMAGE_TO_S3, uploadImageToS3, UPLOAD_CUSTOM_PHOTO_TO_S3, uploadCustomPhotoToS3,
} from "../actions/store";





function* handleUpdateActiveItem(action) {
    try {
        const response = yield call(authenticatedAxios.post,
            `${window.react_giftya_base_url}/store/active-item/update`,
            {
                wrapping_image: action.data.wrapping_image,
                video: action.data.video
            }
        );
        yield put(updateActiveItemSuccess(response.data));
    } catch (e) {
        yield put(updateActiveItemFailure());
    }
}
export function* watchUpdateActiveItem() {
    yield takeLatest(UPDATE_ACTIVE_ITEM, handleUpdateActiveItem);
}


function* handleFetchAwsUploadDetails(action) {
    try {
        const response = yield call(authenticatedAxios.get,
            `${window.react_giftya_base_url}/aws/video-upload-url`
        );
        yield put(fetchAwsUploadDetailsSuccess(response.data));
    } catch (e) {
        yield put(fetchAwsUploadDetailsFailure());
    }
}
export function* watchFetchAwsUploadDetails() {
    yield takeLatest(FETCH_AWS_UPLOAD_DETAILS, handleFetchAwsUploadDetails);
}


function* handleUploadVideo(action) {
    try {
        //Using just axios makes an unauthenticated call. If you need to be authenticated, use authenticatedAxious
        const response = yield call(axios.put, action.url, action.file);
        yield put(uploadVideoSuccess(response.data));
    } catch (e) {
        yield put(uploadVideoFailure());
    }
}
export function* watchUploadVideo() {
    yield takeLatest(UPLOAD_VIDEO, handleUploadVideo);
}


function* handleStartVideoTranscode(action) {
    try {
        const response = yield call(authenticatedAxios.get,
            `${window.react_giftya_base_url}/aws/video-transcode`,
            {
                params: {
                    filename: action.fileName
                }
            }
        );
        yield put(startVideoTranscodeSuccess(response.data));
    } catch (e) {
        yield put(startVideoTranscodeFailure());
    }
}
export function* watchStartVideoTranscode() {
    yield takeLatest(START_VIDEO_TRANSCODE, handleStartVideoTranscode);
}


function* handleCheckVideoTranscodeStatus(action) {
    try {
        const response = yield call(authenticatedAxios.get,
            `${window.react_giftya_base_url}/aws/video-check-transcoding-status`,
            {
                params: {
                    id: action.id
                }
            }
        );
        yield put(checkVideoTranscodeStatusSuccess(response.data));
    } catch (e) {
        yield put(checkVideoTranscodeStatusFailure(e));
    }
}
export function* watchCheckVideoTranscodeStatus() {
    yield takeLatest(CHECK_VIDEO_TRANSCODE_STATUS, handleCheckVideoTranscodeStatus);
}


function* handleUploadImageToS3({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    let data;
    try {
        const params = new URLSearchParams();
        params.append('image', payload.image);
        const response = yield call(authenticatedAxios.post,
            `${window.react_giftya_base_url}/img/send-to-s3`,
            params
        );

        data = response.data;
    } catch (error) {
        yield put(uploadImageToS3(error, {}, true));
    }

    yield put(uploadImageToS3(data, {'sent': true}));
}
export function* watchUploadImageToS3() {
    yield takeLatest(UPLOAD_IMAGE_TO_S3, handleUploadImageToS3);
}


function* handleUploadCustomPhotoToS3({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    let data;
    try {
        const params = new URLSearchParams();
        params.append('image', payload.image);
        const response = yield call(authenticatedAxios.post,
            `${window.react_giftya_base_url}/img/send-to-s3`,
            params
        );

        data = response.data;
    } catch (error) {
        yield put(uploadCustomPhotoToS3(error, {}, true));
    }

    yield put(uploadCustomPhotoToS3(data, {'sent': true}));
}
export function* watchUploadCustomPhotoToS3() {
    yield takeLatest(UPLOAD_CUSTOM_PHOTO_TO_S3, handleUploadCustomPhotoToS3);
}